(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureComponentRulesController', EditorStructureComponentRulesController);

    EditorStructureComponentRulesController.$inject = ['$scope', '$uibModalInstance'];

    function EditorStructureComponentRulesController($scope, $uibModalInstance) {
        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };
    }
})();
